import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import FluencyPath from "@/components/FluencyPath";
import LanguagesGrid from "@/components/LanguagesGrid";
import HowItWorks from "@/components/HowItWorks";
import LatestPosts from "@/components/LatestPosts";
import BecomeTutor from "@/components/BecomeTutor";
import FluencyCTA from "@/components/FluencyCTA";
import Footer from "@/components/Footer";

const Landing = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Jynio | Learn a Language Your Way with Expert Tutors & AI</title>
        <meta
          name="description"
          content="Master any language with ease. Jynio pairs expert online tutoring with smart AI tools and courses. Stop wishing, start speaking, and learn your way."
        />
        <meta
          property="og:title"
          content="Jynio | Learn a Language Your Way with Expert Tutors & AI"
        />
        <meta
          property="og:description"
          content="Master any language with ease. Jynio pairs expert online tutoring with smart AI tools and courses. Stop wishing, start speaking, and learn your way."
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <Hero />
      <FluencyPath />
      <LanguagesGrid />
      <HowItWorks />
      <LatestPosts />
      <BecomeTutor />
      <FluencyCTA />
      <Footer />
    </div>
  );
};

export default Landing;
